import { Link, useLocation, useNavigate } from "react-router-dom";
import { Mail, LifeBuoy } from "lucide-react";
import { goToSection } from "@/lib/scroll";

export const Footer = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const go = (id) => goToSection(id, location.pathname, navigate);

  const productLinks = [
    { label: "The Offer", id: "offer" },
    { label: "How It Works", id: "how-it-works" },
    { label: "Pricing", id: "pricing" },
    { label: "Use Cases", id: "success" },
    { label: "FAQ", id: "faq" },
  ];

  return (
    <footer className="border-t-2 border-white/10 bg-hero-black py-16 text-white" data-testid="footer">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid gap-12 md:grid-cols-2 lg:grid-cols-6">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-3">
              <img src="/logo-transparent.webp" alt="RealEstateHero360 logo" className="h-12 w-auto" />
              <span className="font-display text-lg font-bold uppercase tracking-tight leading-none">
                RealEstate<span className="text-hero-blue">Hero</span><span className="text-hero-gold">360</span>
              </span>
            </div>
            <p className="mt-5 max-w-sm text-sm leading-relaxed text-white/60">
              360° Real Estate Marketing — Room Tours. Drone Flights. Promo Clips.
              Custom-made for companies in the US, UK, Canada & Australia.
            </p>
          </div>

          <nav aria-label="Product">
            <h3 className="font-display text-sm font-semibold uppercase tracking-[0.2em] text-hero-gold">Product</h3>
            <ul className="mt-4 space-y-3">
              {productLinks.map((l) => (
                <li key={l.id}>
                  <button onClick={() => go(l.id)} data-testid={`footer-link-${l.id}`} className="text-sm text-white/70 transition-colors hover:text-hero-gold">
                    {l.label}
                  </button>
                </li>
              ))}
            </ul>
          </nav>

          <nav aria-label="Company">
            <h3 className="font-display text-sm font-semibold uppercase tracking-[0.2em] text-hero-gold">Company</h3>
            <ul className="mt-4 space-y-3">
              <li><a href="/blog/" data-testid="footer-link-blog" className="text-sm text-white/70 transition-colors hover:text-hero-gold">Blog</a></li>
              <li><a href="mailto:hello@realestatehero360.com" data-testid="footer-link-contact" className="text-sm text-white/70 transition-colors hover:text-hero-gold">Contact</a></li>
            </ul>
          </nav>

          <nav aria-label="Legal">
            <h3 className="font-display text-sm font-semibold uppercase tracking-[0.2em] text-hero-gold">Legal</h3>
            <ul className="mt-4 space-y-3">
              <li><Link to="/privacy" data-testid="footer-link-privacy" className="text-sm text-white/70 transition-colors hover:text-hero-gold">Privacy Policy</Link></li>
              <li><Link to="/terms" data-testid="footer-link-terms" className="text-sm text-white/70 transition-colors hover:text-hero-gold">Terms of Service</Link></li>
              <li><Link to="/privacy" data-testid="footer-link-cookies" className="text-sm text-white/70 transition-colors hover:text-hero-gold">Cookie Policy</Link></li>
            </ul>
          </nav>

          <nav aria-label="Contact">
            <h3 className="font-display text-sm font-semibold uppercase tracking-[0.2em] text-hero-gold">Contact</h3>
            <ul className="mt-4 space-y-3">
              <li>
                <a href="mailto:hello@realestatehero360.com" data-testid="footer-link-email" className="inline-flex items-center gap-2 text-sm text-white/70 transition-colors hover:text-hero-gold">
                  <Mail className="h-4 w-4" /> hello@realestatehero360.com
                </a>
              </li>
              <li>
                <a href="mailto:support@realestatehero360.com" data-testid="footer-link-support" className="inline-flex items-center gap-2 text-sm text-white/70 transition-colors hover:text-hero-gold">
                  <LifeBuoy className="h-4 w-4" /> Support
                </a>
              </li>
            </ul>
          </nav>
        </div>

        <div className="mt-14 border-t border-white/10 pt-8 text-center">
          <p className="text-sm text-white/50" data-testid="footer-copyright">
            © 2026 RealEstateHero360. All rights reserved. Trusted by 20+ real estate teams in the US & UK.
          </p>
        </div>
      </div>
    </footer>
  );
};
